import ProfessionalServicePage from "../components/ProfessionalServicePage";

function ProfessionalServiceLanding({ service }) {
  if (!service) {
    return null;
  }

  return <ProfessionalServicePage service={service} />;
}

export default ProfessionalServiceLanding;
